import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMegaphone2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMegaphone2"><Path d="M12 17.5986V22H8V16.5H9.66406L12 17.5986Z" fill="currentColor"/><Path d="M18.5 19L10.5 15V7L18.5 3V19Z" fill="currentColor"/><Path d="M9 15H5.5C3.29086 15 1.5 13.2091 1.5 11C1.5 8.79086 3.29086 7 5.5 7H9V15Z" fill="currentColor"/><Path d="M20 9C21.3807 9 22.5 10.1193 22.5 11.5C22.5 12.8807 21.3807 14 20 14V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMegaphone2;
